import { Button, BUTTON_THEMES } from 'ht-styleguide';

type SelectPlanButtonProps = {
  label?: string;
  addToCart: BaseAnyFunction;
  className?: string;
};
const SelectPlanButton = ({ label = 'Select Membership', addToCart, className = '' }: SelectPlanButtonProps) => (
  <Button medium theme={BUTTON_THEMES.PRIMARY} className={className} onClick={addToCart} dataTestId="plan-submit-button">
    {label}
  </Button>
);

export default SelectPlanButton;
